exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head {\n    padding: 16px 20px;\n    margin-bottom: 0;\n    background-color: #f7f7f9;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    cursor: pointer;\n}\n.speaker-data {\n    border: 1px solid rgba(0,0,0,.125);\n    padding: 15px;\n    margin-top: 20px;\n    clear: both;\n}\n.speaker-img img {\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n}\n.speaker-name {\n    padding-left: 65px;\n    display: block;\n}\n.speaker-img {\n    position: relative;\n}\n.speaker-name label {\n    display: block;\n    margin: 0;\n}\n.speaker-btn-grp {\n    padding-top: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/speakers-form/speakers-form.component.css
// module id = ../../../../../src/app/event/speakers-form/speakers-form.component.css
// module chunks = main